/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity, View } from "react-native";
import Icon from "react-icons-kit";
import { checkCircle } from "react-icons-kit/fa/checkCircle";
import { circleO } from "react-icons-kit/fa/circleO";

import { upduoPrimaryBlue, skaleDeactiveGray } from "config/UpduoColors";
import { Text } from "UpduoLibrary";

interface RatingChoiceProps {
  rating: number;
  value: number;
  onChange: (value: number) => void;
}

function RatingChoice({ rating, value, onChange }: RatingChoiceProps) {
  return (
    <TouchableOpacity
      style={{ margin: 5, alignItems: "center" }}
      onPress={() => {
        onChange(value);
      }}
    >
      <Text>{value}</Text>
      <div
        style={{
          color: rating === value ? upduoPrimaryBlue : skaleDeactiveGray,
        }}
      >
        <Icon icon={rating === value ? checkCircle : circleO} size={30} />
      </div>
      <Text style={{ color: "transparent" }}>{value}</Text>
    </TouchableOpacity>
  );
}

interface RatingProps {
  rating: number;
  lowText?: string;
  highText?: string;
  onChange: (value: number) => void;
}

export default function Rating({
  rating,
  lowText = "Not at all effective",
  highText = "Extremely effective",
  onChange,
}: RatingProps) {
  return (
    <View
      style={{
        flexDirection: "row",
        marginBottom: 10,
        alignItems: "center",
        alignSelf: "center",
      }}
    >
      <Text style={{ margin: 20 }}>{lowText}</Text>
      <RatingChoice rating={rating} value={1} onChange={onChange} />
      <RatingChoice rating={rating} value={2} onChange={onChange} />
      <RatingChoice rating={rating} value={3} onChange={onChange} />
      <RatingChoice rating={rating} value={4} onChange={onChange} />
      <RatingChoice rating={rating} value={5} onChange={onChange} />
      <Text style={{ margin: 20 }}>{highText}</Text>
    </View>
  );
}
